import React from 'react';
import { Button, Result } from 'antd';
import { useNavigate } from 'react-router-dom';
import { useIsAdmin, useIsIsgUser } from '../utils/role';

const NotFoundPage: React.FC = () => {
  const navigate = useNavigate();
  const isAdmin = useIsAdmin();
  const isIsg = useIsIsgUser();

  return (
    <Result
      status="404"
      title="404"
      subTitle="Üzgünüz, aradığınız sayfa bulunamadı."
      extra={
        <Button 
          type="primary" 
          onClick={() => {
            
            if(isAdmin){
              navigate('/admin/dashboard');
            } else if(isIsg){
              navigate('/isg/home');
            } else {
              navigate('/firm/home');
            }
          }}
        >
          Ana Sayfaya Dön
        </Button>
      }
    />
  );
};

export default NotFoundPage;